<template>
	<AppModal :settings="modalSettings">
		<AgreementModalContent />
	</AppModal>
</template>

<script>
import AppModal from '@/components/App/AppModal';
import AgreementModalContent from './AgreementModalContent';

export default {
	components: {
		AppModal,
		AgreementModalContent,
	},
	data() {
		return {
			modalSettings: {
				name: 'modalAgreement',
				title: '회원 이용 약관',
				isOpen: true,
			},
		};
	},
};
</script>
